import styled from 'styled-components';
import { ButtonProps } from '@fluentui/react-components';
import {
  PrimaryButton,
  SecondaryButton,
} from 'src/styles/globalStyles/buttonStyles.styled';

export const RequestDetailsCancelContainer = styled.div`
  background: ${(props) => props.theme.popupInputMainBackground};
  left: 50%;
  width: 20rem;
  height: 12rem;
  padding: 1.3rem;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const RequestDetailsCancelTitle = styled.h2`
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.cancelPopupTitleColor};
`;

export const RequestDetailsCancelParagraph = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${(props) => props.theme.popupParagraphColor};
`;

export const RequestDetailsCancelTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 60%;
  justify-content: space-between;
`;

export const RequestDetailsCancelButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.7rem;
  width: 100%;
`;

export const RequestDetailsPrimaryButton = styled(PrimaryButton)<ButtonProps>`
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;

  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.32),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.28);
  border-radius: 4px;
  border: none;
  padding: 0px 12px;
  height: 32px;

  &:hover {
    padding: 0px 12px;
    border: none;
  }

  cursor: pointer;
`;

export const DefaultButtonStyle = styled(SecondaryButton)<ButtonProps>`
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  border-radius: 4px;
  padding: 0px 12px;
  height: 32px;

  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
`;
